import { useSelector } from "react-redux";
import { useGetOrgLicensedProducts } from "../../../hooks/ReactQueryHooks/useGetOrgLicensedProducts";

export const PERM_MANAGE_SCHEDULE_CATEGORY = "Manage Schedule Category";
export const PERM_MANAGE_PROVIDER_SCHEDULE = "Manage Provider Schedule & Appointments";
export const PERM_APPOINTMENT = "Appointment";

export function useSchedulingPermissions() {
  const user = useSelector((state) => state?.auth?.user);
  const permissions = user?.permissions || [];
  const roles = user?.["cognito:groups"] || [];
  const admin = roles.includes("Super-Admin");
  const practitioner = roles.includes("Practitioner");
  const { data: licensed, isLoading } = useGetOrgLicensedProducts({});
  const virtualCare = admin ? true : !!licensed?.virtualCare;

  return {
    user,
    permissions,
    admin,
    practitioner,
    virtualCare,
    isLoading,
    canManageCategories: admin || (permissions.includes(PERM_MANAGE_SCHEDULE_CATEGORY) && virtualCare),
    canManageProviderSchedules:
      admin || (permissions.includes(PERM_MANAGE_PROVIDER_SCHEDULE) && virtualCare),
    canManageOwnSchedule: practitioner && virtualCare,
    canOpenSchedule:
      admin ||
      (practitioner && virtualCare) ||
      (permissions.includes(PERM_MANAGE_PROVIDER_SCHEDULE) && virtualCare),
    canCreateEditSchedule:
      admin || practitioner || permissions.includes(PERM_MANAGE_PROVIDER_SCHEDULE),
    canManageAppointments:
      admin || practitioner || ((permissions.includes(PERM_APPOINTMENT) || permissions.includes(PERM_MANAGE_PROVIDER_SCHEDULE)) && virtualCare),
  };
}
